<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="处理状态" prop="processStatus">
                <a-select v-model="queryParam.processStatus" placeholder="请选择处理状态">
                  <a-select-option :value="1">待处理</a-select-option>
                  <a-select-option :value="2">已处理</a-select-option>
                  <a-select-option :value="3">暂不处理</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="处理结果" prop="processResult">
                  <a-input v-model="queryParam.processResult" allow-clear placeholder="请输入处理结果"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="联系方式" prop="contact">
                  <a-input v-model="queryParam.contact" allow-clear placeholder="请输入联系方式"/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
                    class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo"/>重置</a-button>
                <a style="margin-left: 8px" @click="toggleAdvanced">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button v-hasPermi="['app:feedback:remove']" :disabled="multiple" type="danger" @click="handleDelete">
          <a-icon type="delete"/>
          删除
        </a-button>
        <table-setting
          v-model="columns"
          :refresh-loading="loading"
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          @refresh="getList"/>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :bordered="tableBordered"
        :columns="columns"
        :data-source="list"
        :loading="loading"
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :size="tableSize"
        rowKey="id"
      >
        <span slot="type" slot-scope="text, record">
          <a-tag v-if="record.type === 1" color="blue">意见建议</a-tag>
          <a-tag v-else-if="record.type === 2" color="orange">故障报告</a-tag>
          <a-tag v-else-if="record.type === 3" color="red">投诉</a-tag>
          <a-tag v-else color="default">未知</a-tag>
        </span>
        <span slot="processStatus" slot-scope="text, record">
          <a-tag v-if="record.processStatus === 1" color="orange">待处理</a-tag>
          <a-tag v-else-if="record.processStatus === 2" color="green">已处理</a-tag>
          <a-tag v-else-if="record.processStatus === 3" color="default">暂不处理</a-tag>
          <a-tag v-else color="default">未知</a-tag>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a :disabled="record.processStatus !== 1" @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit"/>处理
          </a>
          <a-divider v-hasPermi="['app:feedback:remove']" type="vertical"/>
          <a v-hasPermi="['app:feedback:remove']" @click="handleDelete(record)">
            <a-icon type="delete"/>删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        :current="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        :total="total"
        class="ant-table-pagination"
        show-quick-jumper
        show-size-changer
        @change="changeSize"
        @showSizeChange="onShowSizeChange"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {delFeedback, pageFeedback} from '@/api/app/feedback'
import CreateForm from './modules/CreateForm'
import {tableMixin} from '@/store/table-mixin'

export default {
  name: 'Feedback',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        type: null,
        content: null,
        processStatus: undefined,
        processResult: null,
        contact: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '反馈类型',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'type' }
        },
        {
          title: '反馈内容',
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '处理状态',
          dataIndex: 'processStatus',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'processStatus' }
        },
        {
          title: '处理结果',
          dataIndex: 'processResult',
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: '反馈图片地址集合,JSONArray的字符串',
          dataIndex: 'imgUrls',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '联系方式',
          dataIndex: 'contact',
          width: 150,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '提交时间',
          dataIndex: 'createTime',
          scopedSlots: {customRender: 'createTime'},
          width: 180,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    if (!(this.$route.query && this.$route.query.id)) {
      this.getList()
    }
  },
  computed: {},
  watch: {
    '$route.query.id': {
      handler (id) {
        this.openDetailFromRoute(id)
      },
      immediate: true
    }
  },
  methods: {
    openDetailFromRoute (id) {
      if (id == null || id === '') {
        return
      }
      const status = this.$route.query.status
      if (status !== undefined && status !== null && status !== '') {
        const n = parseInt(status, 10)
        if (!Number.isNaN(n)) {
          this.queryParam.processStatus = n
        }
      }
      this.queryParam.pageNum = 1
      this.getList()
      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.handleUpdate({ id }, undefined)
        }
        this.clearRouteDetailIdQuery()
      })
    },
    clearRouteDetailIdQuery () {
      const q = { ...(this.$route.query || {}) }
      if (!q.id) {
        return
      }
      delete q.id
      this.$router.replace({ path: this.$route.path, query: q }).catch(() => {})
    },
    /** 查询意见反馈列表 */
    getList() {
      this.loading = true
      pageFeedback(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        userId: undefined,
        type: undefined,
        content: undefined,
        processStatus: undefined,
        processResult: undefined,
        imgUrls: undefined,
        contact: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map(id => data.push({"id": id}))
          return delFeedback(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('app/appFeedback/export', {
            ...that.queryParam
          }, `意见反馈_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
